import React from 'react';
import { GenericFilterHeader } from './GenericFilterHeader';

const SAP_OUTCOME_OPTIONS = [
    'All',
    'N/A',
    'Successful',
    'Processing',
    'Failed',
    'Some Failed',
];

interface SapOutcomeColumnHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

export function SapOutcomeHeader({
    currentValue,
    onChange,
}: SapOutcomeColumnHeaderProps) {
    return (
        <GenericFilterHeader
            label="SAP Outcome"
            filterOptions={SAP_OUTCOME_OPTIONS}
            currentValue={currentValue}
            onChange={onChange}
        />
    );
}

SapOutcomeHeader.displayName = 'SapOutcomeHeader';
